// extracted by mini-css-extract-plugin
module.exports = {"headerWrap":"header-module--headerWrap--oAc_h","text":"header-module--text--3lhrU","link":"header-module--link--1g7Q7","slashSpan":"header-module--slashSpan--1JkTj"};